import { Injectable } from '@angular/core'
import { EventAttributes, MembershipAttributes, PageAttributes } from 'app/models/analytics.attributes'
import { environment } from 'environments/environment'
import { SeFeAnalytics } from 'se-analytics-js'

@Injectable({
  providedIn: 'root'
})
export class SeAnalyticsService {
  private analytics: SeFeAnalytics = new SeFeAnalytics(
    { platProp: 'membership_ui', platformSubSec: 'Memberships', currentEnv: environment.name }
  )

  constructor() {
    // noop
  }

  public pageView(pageAttributes: PageAttributes, membershipAttributes?: MembershipAttributes): void {
    try {
      const data = { ...pageAttributes, ...membershipAttributes }
      this.analytics.push({ type: 'pageView', data })
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.error('se-analytics pageView Error', e)
    }
  }

  public seEvent(
    pageAttributes: PageAttributes,
    eventAttributes: EventAttributes,
    membershipAttributes?: MembershipAttributes
  ): void {
    try {
      const data = { ...pageAttributes, ...eventAttributes, ...membershipAttributes }
      this.analytics.push({ type: 'seEvent', data })
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.error('mParticle seEvent Error', e)
    }
  }
}
